export default  [
  '#6bcc75',
  '#65c78b',
  '#5fc2a0',
  '#5abead',
  '#52b9c7',
  '#4fb6d2',
  '#4ab2e5',
  '#52b9c7',
  '#5abead',
  '#dfae10',
  '#d5b314',
  '#c1bb1f',
  '#f34e2b',
  '#f56321',
  '#f56f1c',
  '#4ab2e5',
  '#4fb6d2',
  '#f58414',
  '#f58f0e',
  '#f5a305',
  '#e7ab0b',
  '#b9be23',
  '#e7ab0b',
  '#dfae10',
  '#d5b314',
  '#c1bb1f',
  '#b9be23',
  '#a6c62c',
  '#96cc34',
  '#89d23b',
  '#7ed741',
  '#77d64c',
  '#71d162',
];